<script lang="ts">
    import type {MessageUnsupported} from "./Types";
</script>
{""}
